import React from "react";
import ReactDOM from "react-dom";
import axios from 'axios';

import withRouter from '../libs/withRouter.jsx';
import withAuth from "../libs/withAuth.jsx";
import Notification from "../libs/notification.jsx";

import { Link } from "monday-ui-react-core";
import { Info, ExternalPage } from "monday-ui-react-core/dist/allIcons";

class Announcements extends React.Component
{
    constructor(props)
    {
        super(props);
        
        this.user = this.props.auth.user;
        
        this.state = {
            list: []
        };
        
        this.loader = React.createRef();
    }
    
    async promisedSetState(newState)
    { 
        var state = this.state;
        for(let key of Object.keys(newState))
        {
            state[key] = newState[key];
        }
        
        this.state = state;
        
        var this_component = this;
        if(this.synStateTimer==false)
        {
            this.synStateTimer = setTimeout( () => { 
                this_component.setState( {...this_component.state} );
                this_component.synStateTimer = false; 
                this_component.forceUpdate();
            }, 100);
        }
        
        return true;
    }
    
    openInNewTab(e,url)
    {
        e.preventDefault();
        e.stopPropagation();
        window.open(url, '_blank', 'noopener,noreferrer');
    }
    
    async loadData()
    {
        var this_component = this;
        
        var data = {};
        var url = '/api/v1/announcements';
        
        try
        {
            var response = await axios.get(url, { 'params': data} );
            
            //console.log('items', items);
            await this_component.promisedSetState({'list': [...response.data.list]});
            
            this_component.forceUpdate();
        }
        catch( error)
        {
            console.log('Announcements list error', error, error.response);
            //console.error(error);
            this_component.forceUpdate();
        }
    }
    
    async componentDidMount()
    {
        var this_component = this;
        
        await this_component.loadData();
    }
    
    
    render()
    {
        var this_component = this;
        
        return (
            <>
            {
                this_component.state.list.map(
                    function(item, index) {
                        return (
                            <Notification key={"announcements_"+item.id} id={"announcements_"+item.id} backgroundColor="var(--primary-selected-color)">
                                <Info style={{ 'verticalAlign': 'top' }} /> {item.title} <Link text={"more"} href={item.link} inlineText textClassName="textBold" onClick={(e) => this_component.openInNewTab(e, item.link )} iconPosition="end" icon={ExternalPage} />
                            </Notification>
                        );
                    }
                )
            }
            </>
        );
    }
}

Announcements.defaultProps = {
};

export default withRouter(withAuth(Announcements));
